// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");
var Warning_modal = require("../ui-utils/Warning_modal.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var List = require("@mui/material/List").default;
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");
var ListItem = require("@mui/material/ListItem").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var MM_macros_set_mm_example = require("./MM_macros_set_mm_example.res.js");
var FormControl = require("@mui/material/FormControl").default;
var ListItemText = require("@mui/material/ListItemText").default;
var Warning = require("@mui/icons-material/Warning").default;
var ListItemButton = require("@mui/material/ListItemButton").default;

var macrosGlobalContext = {};

var macrosCache = Belt_HashMapString.make(1);

function createMacroFromObject(obj) {
  var runFn = Raw_js_utils.reqFuncExn(obj.run, "'run' attribute of a macro must be a function.");
  return {
          displayName: Raw_js_utils.reqStrExn(obj.displayName, "'displayName' attribute of a macro must be a string."),
          run: (function (ctx) {
              runFn(ctx);
            })
        };
}

function stringToMacros(displayName, script) {
  var msg = Raw_js_utils.invokeExnFunc("Execute the script for '" + displayName + "'", (function () {
          return Raw_js_utils.executeFunctionBody(script);
        }));
  if (msg.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
  var macros = msg._0;
  return Raw_js_utils.invokeExnFunc("Convert macros from the script for '" + displayName + "' to internal representation", (function () {
                return macros.map(createMacroFromObject);
              }));
}

function getMacrosCacheKey(displayName, script) {
  return displayName + " ### " + script;
}

function getMacrosFromCache(displayName, script) {
  var cacheKey = getMacrosCacheKey(displayName, script);
  var macros = Belt_HashMapString.get(macrosCache, cacheKey);
  if (macros !== undefined) {
    return macros;
  }
  var macros$1 = stringToMacros(displayName, script);
  Belt_HashMapString.set(macrosCache, cacheKey, macros$1);
  return macros$1;
}

function removeStaleMacrosFromCache(st) {
  var validKeys = st.collsOfMacros.map(function (coll) {
        return getMacrosCacheKey(coll.displayName, coll.scriptText);
      });
  var allKeys = Belt_HashMapString.keysToArray(macrosCache);
  allKeys.forEach(function (key) {
        if (!validKeys.includes(key)) {
          return Belt_HashMapString.remove(macrosCache, key);
        }
        
      });
}

var setMmExampleScript = MM_macros_set_mm_example.setMmExampleMacros.replace(/\[!@#\]/g, "`").replace(/\{!@#\}/g, "$");

var setMmExampleDisplayName = "set.mm example macros";

function makeEmptyState() {
  return {
          nextId: 0,
          activeCollOfMacrosId: -1,
          collsOfMacros: [{
              id: -1,
              version: 1,
              displayName: setMmExampleDisplayName,
              displayNameEdit: setMmExampleDisplayName,
              scriptText: setMmExampleScript,
              scriptTextEdit: setMmExampleScript,
              macros: getMacrosFromCache(setMmExampleDisplayName, setMmExampleScript)
            }]
        };
}

function addNewCollOfMacros(st) {
  var displayName = "Macros-" + String(st.nextId + 1 | 0);
  var scriptText = "return [{displayName:'empty macro', run:() => console.log('empty macro')}]";
  return {
          nextId: st.nextId + 1 | 0,
          activeCollOfMacrosId: st.nextId,
          collsOfMacros: Belt_Array.concatMany([
                [{
                    id: st.nextId,
                    version: 1,
                    displayName: displayName,
                    displayNameEdit: displayName,
                    scriptText: scriptText,
                    scriptTextEdit: scriptText,
                    macros: getMacrosFromCache(displayName, scriptText)
                  }],
                st.collsOfMacros
              ])
        };
}

function deleteMacros(st, id) {
  if (id < 0) {
    return {
            TAG: "Error",
            _0: "Cannot delete these macros because they are read-only."
          };
  } else {
    return {
            TAG: "Ok",
            _0: {
              nextId: st.nextId,
              activeCollOfMacrosId: st.activeCollOfMacrosId,
              collsOfMacros: st.collsOfMacros.filter(function (macros) {
                    return macros.id !== id;
                  })
            }
          };
  }
}

function saveEdits(st, id) {
  if (id < 0) {
    return {
            TAG: "Error",
            _0: "Cannot update these macros because they are read-only."
          };
  }
  var st_nextId = st.nextId;
  var st_activeCollOfMacrosId = st.activeCollOfMacrosId;
  var st_collsOfMacros = st.collsOfMacros.map(function (collOfMacros) {
        if (collOfMacros.id !== id) {
          return collOfMacros;
        } else {
          return {
                  id: collOfMacros.id,
                  version: collOfMacros.version + 1 | 0,
                  displayName: collOfMacros.displayNameEdit,
                  displayNameEdit: collOfMacros.displayNameEdit,
                  scriptText: collOfMacros.scriptTextEdit,
                  scriptTextEdit: collOfMacros.scriptTextEdit,
                  macros: getMacrosFromCache(collOfMacros.displayNameEdit, collOfMacros.scriptTextEdit)
                };
        }
      });
  var st$1 = {
    nextId: st_nextId,
    activeCollOfMacrosId: st_activeCollOfMacrosId,
    collsOfMacros: st_collsOfMacros
  };
  removeStaleMacrosFromCache(st$1);
  return {
          TAG: "Ok",
          _0: st$1
        };
}

function setDisplayNameEdit(st, collOfMacrosId, displayNameEdit) {
  if (collOfMacrosId < 0) {
    return {
            TAG: "Error",
            _0: "Cannot update these macros because they are read-only."
          };
  } else {
    return {
            TAG: "Ok",
            _0: {
              nextId: st.nextId,
              activeCollOfMacrosId: st.activeCollOfMacrosId,
              collsOfMacros: st.collsOfMacros.map(function (collOfMacros) {
                    if (collOfMacros.id !== collOfMacrosId) {
                      return collOfMacros;
                    } else {
                      return {
                              id: collOfMacros.id,
                              version: collOfMacros.version,
                              displayName: collOfMacros.displayName,
                              displayNameEdit: displayNameEdit,
                              scriptText: collOfMacros.scriptText,
                              scriptTextEdit: collOfMacros.scriptTextEdit,
                              macros: collOfMacros.macros
                            };
                    }
                  })
            }
          };
  }
}

function setScriptTextEdit(st, collOfMacrosId, scriptTextEdit) {
  if (collOfMacrosId < 0) {
    return {
            TAG: "Error",
            _0: "Cannot update these macros because they are read-only."
          };
  } else {
    return {
            TAG: "Ok",
            _0: {
              nextId: st.nextId,
              activeCollOfMacrosId: st.activeCollOfMacrosId,
              collsOfMacros: st.collsOfMacros.map(function (collOfMacros) {
                    if (collOfMacros.id !== collOfMacrosId) {
                      return collOfMacros;
                    } else {
                      return {
                              id: collOfMacros.id,
                              version: collOfMacros.version,
                              displayName: collOfMacros.displayName,
                              displayNameEdit: collOfMacros.displayNameEdit,
                              scriptText: collOfMacros.scriptText,
                              scriptTextEdit: scriptTextEdit,
                              macros: collOfMacros.macros
                            };
                    }
                  })
            }
          };
  }
}

function resetEditsForCollOfMacros(st, id) {
  if (id < 0) {
    return {
            TAG: "Error",
            _0: "Cannot update these macros because they are read-only."
          };
  } else {
    return {
            TAG: "Ok",
            _0: {
              nextId: st.nextId,
              activeCollOfMacrosId: st.activeCollOfMacrosId,
              collsOfMacros: st.collsOfMacros.map(function (collOfMacros) {
                    if (collOfMacros.id !== id) {
                      return collOfMacros;
                    } else {
                      return {
                              id: collOfMacros.id,
                              version: collOfMacros.version,
                              displayName: collOfMacros.displayName,
                              displayNameEdit: collOfMacros.displayName,
                              scriptText: collOfMacros.scriptText,
                              scriptTextEdit: collOfMacros.scriptText,
                              macros: collOfMacros.macros
                            };
                    }
                  })
            }
          };
  }
}

function setActiveCollOfMacrosId(st, newActiveCollOfMacrosId) {
  var match = st.collsOfMacros.find(function (coll) {
        return coll.id === newActiveCollOfMacrosId;
      });
  if (match === undefined) {
    return {
            TAG: "Ok",
            _0: st
          };
  }
  var st_nextId = st.nextId;
  var st_collsOfMacros = st.collsOfMacros;
  var st$1 = {
    nextId: st_nextId,
    activeCollOfMacrosId: newActiveCollOfMacrosId,
    collsOfMacros: st_collsOfMacros
  };
  if (newActiveCollOfMacrosId < 0) {
    return {
            TAG: "Ok",
            _0: st$1
          };
  } else {
    return resetEditsForCollOfMacros(st$1, newActiveCollOfMacrosId);
  }
}

var expBtnBaseStyle = {
  border: "1px solid",
  color: "grey",
  cursor: "pointer",
  display: "block",
  fontFamily: "courier",
  fontSize: "10px",
  marginTop: "13px",
  marginRight: "3px",
  padding: "1px 3px 0px 2px"
};

function stateToStateLocStor(st) {
  return {
          activeCollOfMacrosIdx: st.collsOfMacros.findIndex(function (coll) {
                return coll.id === st.activeCollOfMacrosId;
              }),
          collsOfMacros: st.collsOfMacros.filter(function (coll) {
                  return coll.id >= 0;
                }).map(function (coll) {
                return {
                        displayName: coll.displayName,
                        scriptText: coll.scriptText
                      };
              })
        };
}

function stateLocStorToState(ls) {
  var defaultColls = [{
      id: -1,
      version: 1,
      displayName: setMmExampleDisplayName,
      displayNameEdit: setMmExampleDisplayName,
      scriptText: setMmExampleScript,
      scriptTextEdit: setMmExampleScript,
      macros: getMacrosFromCache(setMmExampleDisplayName, setMmExampleScript)
    }];
  var collsOfMacros = Belt_Array.concatMany([
        ls.collsOfMacros.map(function (coll, i) {
              return {
                      id: i,
                      version: 1,
                      displayName: coll.displayName,
                      displayNameEdit: coll.displayName,
                      scriptText: coll.scriptText,
                      scriptTextEdit: coll.scriptText,
                      macros: getMacrosFromCache(coll.displayName, coll.scriptText)
                    };
            }),
        defaultColls
      ]);
  var coll = Belt_Array.get(collsOfMacros, ls.activeCollOfMacrosIdx);
  return {
          nextId: ls.collsOfMacros.length,
          activeCollOfMacrosId: coll !== undefined ? coll.id : 0,
          collsOfMacros: collsOfMacros
        };
}

var macrosLocStorKey = "macros";

function saveStateToLocStor(st) {
  Local_storage_utils.locStorWriteString(macrosLocStorKey, Expln_utils_common.stringify(stateToStateLocStor(st)));
}

function readStateLocStorFromJsonStr(jsonStr) {
  return Expln_utils_jsonParse.parseJson(jsonStr, (function (__x) {
                return Expln_utils_jsonParse.asObj(__x, (function (d) {
                              return {
                                      activeCollOfMacrosIdx: Expln_utils_jsonParse.$$int(d, "activeCollOfMacrosIdx", undefined, undefined),
                                      collsOfMacros: Expln_utils_jsonParse.arr(d, "collsOfMacros", (function (__x) {
                                              return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                            return {
                                                                    displayName: Expln_utils_jsonParse.str(d, "displayName", undefined, undefined),
                                                                    scriptText: Expln_utils_jsonParse.str(d, "scriptText", undefined, undefined)
                                                                  };
                                                          }), undefined, undefined);
                                            }), undefined, undefined)
                                    };
                            }), undefined, undefined);
              }), undefined, undefined);
}

function readStateFromLocStor() {
  var jsonStr = Local_storage_utils.locStorReadString(macrosLocStorKey);
  if (jsonStr === undefined) {
    return makeEmptyState();
  }
  var stateLocStor = readStateLocStorFromJsonStr(jsonStr);
  if (stateLocStor.TAG === "Ok") {
    return stateLocStorToState(stateLocStor._0);
  } else {
    return makeEmptyState();
  }
}

var warningText = "\r\n    Please be careful with what JavaScript code you use for macros. \r\n    This code will be executed by your browser \"as is\" meaning no safety measures will be taken to protect your browser from hurmful code.\r\n    Before putting any code into this dialog please make sure you understand what that code does or make sure the code is not harmful.\r\n";

function MM_cmp_macros(props) {
  var onClose = props.onClose;
  var modalRef = props.modalRef;
  var match = React.useState(readStateFromLocStor);
  var setState = match[1];
  var state = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageBool("macros-dialog-is-expanded", false);
  var setIsExpanded = match$1[1];
  var isExpanded = match$1[0];
  var match$2 = Local_storage_utils.useStateFromLocalStorageBool("custom-macros-js-warning-hide", false);
  var setHideWarning = match$2[1];
  var hideWarning = match$2[0];
  var activeCollOfMacros = state.collsOfMacros.find(function (collOfMacros) {
        return collOfMacros.id === state.activeCollOfMacrosId;
      });
  var thereAreChangesInActiveCollOfMacros = Belt_Option.getWithDefault(Belt_Option.map(activeCollOfMacros, (function (coll) {
              if (coll.displayName !== coll.displayNameEdit) {
                return true;
              } else {
                return coll.scriptText !== coll.scriptTextEdit;
              }
            })), false);
  var activeCollOfMacrosIsReadOnly = Belt_Option.getWithDefault(Belt_Option.map(activeCollOfMacros, (function (coll) {
              return coll.id < 0;
            })), false);
  var actShowWarning = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Warning_modal.make, {
                                title: "Security warning",
                                warningText: warningText,
                                hideInit: hideWarning,
                                onHideChange: (function (b) {
                                    setHideWarning(function (param) {
                                          return b;
                                        });
                                  }),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  React.useEffect((function () {
          if (!activeCollOfMacrosIsReadOnly && !hideWarning && isExpanded) {
            actShowWarning();
          }
          
        }), [activeCollOfMacrosIsReadOnly]);
  var actActiveCollOfMacrosChange = function (newActiveCollOfMacrosIdStr) {
    var id = Belt_Int.fromString(newActiveCollOfMacrosIdStr);
    if (id !== undefined) {
      return setState(function (st) {
                  var st$1 = setActiveCollOfMacrosId(st, id);
                  if (st$1.TAG !== "Ok") {
                    return st;
                  }
                  var st$2 = st$1._0;
                  saveStateToLocStor(st$2);
                  return st$2;
                });
    }
    
  };
  var actSetDisplayNameEdit = function (str) {
    if (activeCollOfMacros === undefined) {
      return ;
    }
    var id = activeCollOfMacros.id;
    setState(function (st) {
          var st$1 = setDisplayNameEdit(st, id, str);
          if (st$1.TAG === "Ok") {
            return st$1._0;
          } else {
            return st;
          }
        });
  };
  var actSetScriptTextEdit = function (str) {
    if (activeCollOfMacros === undefined) {
      return ;
    }
    var id = activeCollOfMacros.id;
    setState(function (st) {
          var st$1 = setScriptTextEdit(st, id, str);
          if (st$1.TAG === "Ok") {
            return st$1._0;
          } else {
            return st;
          }
        });
  };
  var actSaveEdits = function () {
    if (activeCollOfMacros === undefined) {
      return ;
    }
    var id = activeCollOfMacros.id;
    setState(function (st) {
          var st$1 = saveEdits(st, id);
          if (st$1.TAG !== "Ok") {
            return st;
          }
          var st$2 = st$1._0;
          saveStateToLocStor(st$2);
          return st$2;
        });
  };
  var actDeleteActiveCollOfMacros = function () {
    if (activeCollOfMacros === undefined) {
      return ;
    }
    var displayName = activeCollOfMacros.displayName;
    var collId = activeCollOfMacros.id;
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, "Delete \"" + displayName + "\" collection of macros?", React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  children: "Cancel"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (prevSt) {
                                                            var st = deleteMacros(prevSt, collId);
                                                            if (st.TAG !== "Ok") {
                                                              return prevSt;
                                                            }
                                                            var st$1 = st._0;
                                                            var st$2 = setActiveCollOfMacrosId(st$1, st$1.collsOfMacros[0].id);
                                                            if (st$2.TAG !== "Ok") {
                                                              return prevSt;
                                                            }
                                                            var st$3 = st$2._0;
                                                            saveStateToLocStor(st$3);
                                                            return st$3;
                                                          });
                                                    }),
                                                  variant: "contained",
                                                  children: "Delete"
                                                }))))
                              });
                  }));
          }));
  };
  var actAddNewCollOfMacros = function () {
    setState(function (st) {
          var st$1 = addNewCollOfMacros(st);
          saveStateToLocStor(st$1);
          return st$1;
        });
  };
  var rndError = function (msg) {
    return React.createElement("pre", undefined, msg);
  };
  var rndExpBtn = function () {
    return React.createElement("a", {
                style: expBtnBaseStyle,
                onClick: (function (param) {
                    setIsExpanded(function (prev) {
                          return !prev;
                        });
                  })
              }, isExpanded ? "-" : "+");
  };
  var rndMacrosDropdown = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(FormControl, {
                    size: "small",
                    children: Caml_option.some(React.createElement(Select, {
                              sx: {
                                width: 330
                              },
                              value: String(state.activeCollOfMacrosId),
                              onChange: Expln_React_common.evt2str(actActiveCollOfMacrosChange),
                              children: Caml_option.some(state.collsOfMacros.map(function (macros) {
                                        var value = String(macros.id);
                                        return JsxPPXReactSupportU.createElementWithKey(value, MenuItem, {
                                                    value: value,
                                                    children: Caml_option.some(macros.displayName)
                                                  });
                                      }))
                            }))
                  }), rndExpBtn());
  };
  var rndCancelBtn = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onClose();
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }), isExpanded ? null : MM_react_common.rndHiddenTextField(undefined, MM_react_common.kbrdHnds([MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)])));
  };
  var rndScriptTextField = function (collOfMacros) {
    return JsxPPXReactSupportU.createElementWithKey(String(collOfMacros.id), TextField, {
                value: collOfMacros.scriptTextEdit,
                label: "Script",
                size: "small",
                style: {
                  width: activeCollOfMacrosIsReadOnly ? "350px" : "300px"
                },
                multiline: true,
                maxRows: 3,
                onChange: Expln_React_common.evt2str(actSetScriptTextEdit),
                onKeyDown: MM_react_common.kbrdHnds([
                      MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSaveEdits),
                      MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)
                    ]),
                disabled: activeCollOfMacrosIsReadOnly,
                autoFocus: true
              });
  };
  var rndEditControls = function () {
    if (!isExpanded || activeCollOfMacros === undefined) {
      return null;
    } else {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement(TextField, {
                      value: activeCollOfMacros.displayNameEdit,
                      label: "Display name",
                      size: "small",
                      style: {
                        width: "350px"
                      },
                      onChange: Expln_React_common.evt2str(actSetDisplayNameEdit),
                      onKeyDown: MM_react_common.kbrdHnds([
                            MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actSaveEdits),
                            MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onClose)
                          ]),
                      disabled: activeCollOfMacros.id < 0
                    }), activeCollOfMacrosIsReadOnly ? rndScriptTextField(activeCollOfMacros) : React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(IconButton, {
                                        onClick: (function (param) {
                                            actShowWarning();
                                          }),
                                        color: "orange",
                                        title: "Security warning",
                                        children: Caml_option.some(React.createElement(Warning, {}))
                                      })), React.createElement("td", {
                                    style: {
                                      paddingLeft: "5px"
                                    }
                                  }, rndScriptTextField(activeCollOfMacros))))), React.createElement(Expln_React_Row.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Button, {
                          onClick: (function (param) {
                              actSaveEdits();
                            }),
                          variant: "contained",
                          disabled: !thereAreChangesInActiveCollOfMacros,
                          children: "Save changes"
                        }), React.createElement(Button, {
                          onClick: (function (param) {
                              actAddNewCollOfMacros();
                            }),
                          variant: "outlined",
                          children: "Add new"
                        }), React.createElement(Button, {
                          onClick: (function (param) {
                              actDeleteActiveCollOfMacros();
                            }),
                          variant: "outlined",
                          disabled: activeCollOfMacrosIsReadOnly,
                          children: "Delete"
                        })));
    }
  };
  var rndActiveMacros = function () {
    if (activeCollOfMacros === undefined) {
      return rndError("Cannot find a collection of macros with id  " + String(state.activeCollOfMacrosId));
    }
    var msg = activeCollOfMacros.macros;
    if (msg.TAG === "Ok") {
      return JsxPPXReactSupportU.createElementWithKey(String(activeCollOfMacros.id), List, {
                  disablePadding: true,
                  children: Caml_option.some(msg._0.map(function (macro, i) {
                            return JsxPPXReactSupportU.createElementWithKey(String(activeCollOfMacros.version) + "-" + String(i), ListItem, {
                                        disablePadding: true,
                                        children: Caml_option.some(React.createElement(ListItemButton, {
                                                  onClick: (function (param) {
                                                      onClose();
                                                      macro.run(macrosGlobalContext);
                                                    }),
                                                  children: Caml_option.some(React.createElement(ListItemText, {
                                                            children: Caml_option.some(macro.displayName)
                                                          }))
                                                }))
                                      });
                          }))
                });
    } else {
      return rndError("There was an error during initialization of this collection of macros:\n" + msg._0);
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, rndMacrosDropdown(), rndEditControls(), rndActiveMacros(), rndCancelBtn()))
            });
}

var make = MM_cmp_macros;

exports.macrosGlobalContext = macrosGlobalContext;
exports.macrosCache = macrosCache;
exports.createMacroFromObject = createMacroFromObject;
exports.stringToMacros = stringToMacros;
exports.getMacrosCacheKey = getMacrosCacheKey;
exports.getMacrosFromCache = getMacrosFromCache;
exports.removeStaleMacrosFromCache = removeStaleMacrosFromCache;
exports.setMmExampleScript = setMmExampleScript;
exports.setMmExampleDisplayName = setMmExampleDisplayName;
exports.makeEmptyState = makeEmptyState;
exports.addNewCollOfMacros = addNewCollOfMacros;
exports.deleteMacros = deleteMacros;
exports.saveEdits = saveEdits;
exports.setDisplayNameEdit = setDisplayNameEdit;
exports.setScriptTextEdit = setScriptTextEdit;
exports.resetEditsForCollOfMacros = resetEditsForCollOfMacros;
exports.setActiveCollOfMacrosId = setActiveCollOfMacrosId;
exports.expBtnBaseStyle = expBtnBaseStyle;
exports.stateToStateLocStor = stateToStateLocStor;
exports.stateLocStorToState = stateLocStorToState;
exports.macrosLocStorKey = macrosLocStorKey;
exports.saveStateToLocStor = saveStateToLocStor;
exports.readStateLocStorFromJsonStr = readStateLocStorFromJsonStr;
exports.readStateFromLocStor = readStateFromLocStor;
exports.warningText = warningText;
exports.make = make;
/* macrosCache Not a pure module */
